import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { BaseFilterProps } from "../types";

/**
 * Version filter component.
 * Renders a list of version options with checkboxes.
 */
export function VersionFilter({
  filter,
  config,
  onValueChange,
}: Omit<BaseFilterProps, 'isActive' | 'onToggle' | 'onRemove'>) {
  return (
    <>
      {config.options?.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer hover:bg-muted p-2 rounded"
        >
          <Checkbox
            checked={filter.values.includes(option.value)}
            onCheckedChange={() => onValueChange(option.value)}
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </>
  );
}

export default VersionFilter;

